import React, { Component } from 'react'

export class SecondScreen extends Component {
    render() {
        return (
            <div>
                <div className="m-body">
                    <img className="m-headerLogo" src={require("../../assets/imgs/logo-blue.png")} alt="logo" />
                    <span className="m-home-text">Test your Child's<br /> 6 Areas of Development</span>
                    <img className="m-6areas" src={require("../../assets/imgs/mobile/6areas.png")} alt="6areas" />
                    <img alt="snake-small" className="m-white-snake2" src={require("../../assets/imgs/mobile/snake.png")} />
                </div>
                <div className="m-bullet-list">
                    <div className="m-bullet"></div>
                    <div className="m-bullet selected-bullet"></div>
                    <div className="m-bullet"></div>
                    <div className="m-bullet"></div>
                </div>
                <p onClick={this.props.nextStep} className="goNext">Next -></p>
            </div>
        )
    }
}

export default SecondScreen
